import { render, staticRenderFns } from "./FakeWorkflowOverview.vue?vue&type=template&id=047206b8&"
import script from "./FakeWorkflowOverview.vue?vue&type=script&lang=ts&"
export * from "./FakeWorkflowOverview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports